import {requests} from "../../utils/helpers/api.services";
import {BASE_PATH} from "../../utils/helpers/api.routes";
import {ErrorToast} from "../../utils/toasters/toasters";

export function getUserRoles() {
    return requests.get(`${BASE_PATH}/enums`)
        .then(data => data?.userRoles)
        .catch(error => ErrorToast(error));
}